import React, { useState, useEffect } from 'react';
import axios from "axios";
import Form from './components/Form';
import List from './components/List';
import Section from './components/Section';

const appTitle = "To-Do App";
const url = "https://todolist-gs.herokuapp.com/todos";

export default function App() {
    const [todoList, setTodoList] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const {data} = await axios.get(url); // destructuring and assigning 
            setTodoList(data);
        }
        fetchData();
    }, []) // only once

    const addTodo = async (item) => {
        const {data} = await axios.post(url, item);
        setTodoList((oldList) => [...oldList, data]);
    };

    const editTodo = async (id, item) => {
        const {data} = await axios.put(`${url}/${id}`, item);
    };

    const deleteTodo = async (id) => {
        await axios.delete(`${url}/${id}`);
        setTodoList((oldList) => oldList.filter((item) => item._id !== id));
    }

    return (
        <>
            <div className="ui container center aligned">
                <Section>
                    <h1>{appTitle}</h1>
                    <p style={{ color: "gray" }}>Double click to edit item</p>
                </Section>
                <Section>
                    <Form addTodo = {addTodo} />
                </Section>
                <Section>
                    <List
                        editTodoList = {editTodo}
                        itemsList={todoList} 
                        deleteTodo = {deleteTodo}
                    />
                </Section>
            </div>
        </>
    )
}
